
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groupe/[slug]",
      function () {
        return require("private-next-pages/groupe/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/groupe/[slug]"])
      });
    }
  